module.exports = __webpack_public_path__ + "img/appletCode.10185943.png";